import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import isOptionExpired from './isOptionExpired'

export default function isStockTradable(stock, contract, getters) {
  const isOPT = stock.secType === SEC_TYPE.OPT
  const isHK = stock.market === MARKET_TYPE.HK
  const isUS = stock.market === MARKET_TYPE.US

  // 服务端返回交易判断(传空默认为 true)
  contract = contract || { tradeable: true }

  // 指数不支持交易
  if (stock.isIndex) return false

  // 提前判断服务端字段
  if (!contract.tradeable) return false

  // 模拟盘不支持港股和期权交易
  if (getters.isVirtual && isOPT && isHK) return false

  // 港股判断交易权限
  if (isHK) return getters.hasHkTradePermission

  // 期权判断权限以及过期时间
  if (isOPT) {
    return getters.hasUsOptTradePermission && !isOptionExpired(stock.expiry)
  }
  return isUS
}
